/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconClosedCaptions from '@telus-uds/palette-allium/build/rn/icons/ClosedCaptions'
import PaletteIconFullscreenExpand from '@telus-uds/palette-allium/build/rn/icons/FullscreenExpand'
import PaletteIconFullscreenMinimize from '@telus-uds/palette-allium/build/rn/icons/FullscreenMinimize'
import PaletteIconSettingsSolid from '@telus-uds/palette-allium/build/rn/icons/SettingsSolid'
const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs', 'sm' ] },
      tokens: {
        height: 40,
        paddingBottom: 16,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 16
      }
    }
  ],
  tokens: {
    captionsIcon: PaletteIconClosedCaptions,
    height: 56,
    maximizeIcon: PaletteIconFullscreenExpand,
    menuBottom: 64,
    menuMarginLeft: 16,
    menuRight: 32,
    minimizeIcon: PaletteIconFullscreenMinimize,
    paddingBottom: 16,
    paddingLeft: 48,
    paddingRight: 48,
    paddingTop: 16,
    settingsIcon: PaletteIconSettingsSolid
  }
}
export default theme
